var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiamondCheck = function SvgIconDiamondCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_diamond_check_svg__a)",
    d: "M18.041 11.793a1 1 0 1 1 1.414 1.414l-4.25 4.25a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.338-1.483l.076.069 1.293 1.293z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_diamond_check_svg__b)",
    fillRule: "evenodd",
    d: "M14.723 3.499c.297 0 .58.133.769.362l2.777 3.732c.322.39.302.96-.046 1.327l-3.935 4.084-.022-.023-.094-.088a2.5 2.5 0 0 0-1.174-.594l3-3.3h-3.25l-1.08 3.391a2.5 2.5 0 0 0-.938 4.127l.089.088-.562.584a.995.995 0 0 1-1.446 0L.773 8.92a1 1 0 0 1-.046-1.327l2.855-3.732A1 1 0 0 1 4.35 3.5zm-6.725 11-1.75-5.5h-3.25zm1.5 0 1.75-5.5h-3.5zm-6.5-7h3.25l.714-2.5H4.585zm4.75 0h3.5l-.75-2.5H8.516zm5 0h3.25l-1.51-2.5h-2.376z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_diamond_check_svg__a",
    x1: 16.165,
    x2: 0.498,
    y1: 10.602,
    y2: 10.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_diamond_check_svg__b",
    x1: 16.165,
    x2: 0.498,
    y1: 10.602,
    y2: 10.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })))));
};
export default SvgIconDiamondCheck;